// angular
import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
// service
import { PwjToastService } from '@app/core/shared/services/app-toast.service';

@Injectable()
export class HandleErrorService {
  public errorMessage!: string;

  // dependencies
  private readonly _toast = inject(PwjToastService);

  constructor() {}

  public handleError(err: HttpErrorResponse) {
    if (err.error instanceof ErrorEvent) {
      this.errorMessage = 'toastMessages.unknownError';
    } else {
      switch (err?.status) {
        case 0:
          this.errorMessage = 'toastMessages.slowInternetConnectionMessage';
          break;
        case 400:
          this.errorMessage =
            err?.error?.message?.message || 'toastMessages.badRequest';
          break;
        case 401:
          this.errorMessage = 'toastMessages.unauthorized';
          break;
        case 403:
          this.errorMessage = 'toastMessages.forbidden';
          break;
        case 404:
          this.errorMessage = 'toastMessages.unknownError';
          break;
        case 412:
          this.errorMessage = 'toastMessages.preconditionFailed';
          break;
        case 500:
          this.errorMessage = 'toastMessages.internalServerError';
          break;
        case 503:
          this.errorMessage = 'toastMessages.serviceUnavailable';
          break;
        default:
          this.errorMessage = 'toastMessages.unknownError';
          break;
      }
    }

    this._toast.error(this.errorMessage, 'toastMessages.errorTitle');
  }
}
